import cx from 'classnames';
import {
    BZ_CONTACT_BUY_IN_eshop,
    BZ_CONTACT_CALL_phone,
    BZ_CONTACT_CALL_phone_OR_BUY_IN_eshop,
    BZ_CONTACT_OR_BUY_IN_eshop,
    BZ_CONTACT_OR_CALL_phone,
    BZ_CONTACT_OR_CALL_phone_AND_BUY_IN_eshop,
} from 'mk/autogenerated/translations/ContactSellerActionsStep1.28e54cc7d4345b330c4554e8588f67cc'
import { Interpolate } from 'mk2/components/Interpolate';
import React from 'react';
import styles from './ContactSellerActionsStep1.mscss';

interface OwnProps {
    sendMsgBtn: React.ReactNode;
    phoneLink: React.ReactNode;
    eshopLink: React.ReactNode;
}

export const ContactSellerActionsStep1: React.FunctionComponent<OwnProps> = ({
    sendMsgBtn, phoneLink, eshopLink,
}) => {

    return sendMsgBtn ? (
        <div className={cx(
            styles.ContactSellerActionsStep1,
            !phoneLink && !eshopLink && styles['ContactSellerActionsStep1--needsBottomPadding'],
        )}>
            {/*
                <Pošli správu> alebo zavolaj na <phone> a kúp na <eshop>
                <Pošli správu> alebo zavolaj na <phone>
                <Pošli správu> alebo kúp na <eshop>
            */}
            {sendMsgBtn}

            {phoneLink && eshopLink && (
                <Interpolate
                    className={styles.ContactSellerActionsStep1__secondary}
                    parent="div"
                    i18nKey={BZ_CONTACT_OR_CALL_phone_AND_BUY_IN_eshop}
                    phone={phoneLink}
                    eshop={eshopLink}
                />
            )}
            {phoneLink && !eshopLink && (
                <Interpolate
                    className={styles.ContactSellerActionsStep1__secondary}
                    parent="div"
                    i18nKey={BZ_CONTACT_OR_CALL_phone}
                    phone={phoneLink}
                />
            )}
            {!phoneLink && eshopLink && (
                <Interpolate
                    className={styles.ContactSellerActionsStep1__secondary}
                    parent="div"
                    i18nKey={BZ_CONTACT_OR_BUY_IN_eshop}
                    eshop={eshopLink}
                />
            )}
        </div>
    ) : (
        (phoneLink || eshopLink) ? (
            <div className={cx(
                styles.ContactSellerActionsStep1,
                styles['ContactSellerActionsStep1--needsBottomPadding'],
            )}>
                {/*
                    Zavolaj na <phone> alebo kúp na <eshop>
                    Zavolaj na <phone>
                    Kúp na <eshop>
                */}
                {phoneLink && eshopLink && (
                    <Interpolate
                        className={cx(
                            styles.ContactSellerActionsStep1__secondary,
                            styles['ContactSellerActionsStep1__secondary--noPrimaryBtn'],
                        )}
                        parent="div"
                        i18nKey={BZ_CONTACT_CALL_phone_OR_BUY_IN_eshop}
                        phone={phoneLink}
                        eshop={eshopLink}
                    />
                )}
                {phoneLink && !eshopLink && (
                    <Interpolate
                        className={cx(
                            styles.ContactSellerActionsStep1__secondary,
                            styles['ContactSellerActionsStep1__secondary--noPrimaryBtn'],
                        )}
                        parent="div"
                        i18nKey={BZ_CONTACT_CALL_phone}
                        phone={phoneLink}
                    />
                )}
                {!phoneLink && eshopLink && (
                    <Interpolate
                        className={cx(
                            styles.ContactSellerActionsStep1__secondary,
                            styles['ContactSellerActionsStep1__secondary--noPrimaryBtn'],
                        )}
                        parent="div"
                        i18nKey={BZ_CONTACT_BUY_IN_eshop}
                        eshop={eshopLink}
                    />
                )}
            </div>
        ) : null
    );
};
